<template>
  <div
    :class="['subsection',{'ui-hidden':hideGlobalUI}]"
    @mouseover="hovering = true"
    @mouseleave="hovering = false"    
    v-toggle-select
    v-on-clickaway="deselect"        
  >
    <subsection-title
      :title="subsection.subsection_title"
      :editable="isEditable"
      :priceColumns="subsection.subsection_price_columns"
      @addPriceColumn="addPriceColumn"
      @update="subsection.subsection_title = $event"
      ref="subsectionTitle"
    />

    <draggable
      class="menu-items"
      v-model="subsection.items"
      v-if="subsection.items.length"
      :options="{group:'menu-items', handle:'.drag-handle'}"
      @start="onDragStart"
      @end="dragging = false"
      @choose="dragging = true"
      @unchoose="dragging = false"
    >
      <!-- <transition-group name="fade" tag="div"> -->
        <menu-item
          v-for="(item, item_index) in subsection.items"
          v-if="!parseInt( wpData.togo ) || ( parseInt( wpData.togo ) && !item.item_isSpecial)"          
          :key="item.item_uuid"
          :item="item"
          :dragging="dragging"
          @removeItem="removeItem"
          @addItem="addItem"
        />
      <!-- </transition-group> -->
    </draggable>

    <transition name="fade">
      <button-cluster
        v-if="showExtras || true"
        :buttons="buttons"
        :item="subsection"
        highlight="navy"
        bottomLeft
      />
    </transition>      
  </div>
</template>

<script>

import draggable from 'vuedraggable'
import EditableTextField from '../EditableTextField'
import MenuSubsectionTitle from './MenuSubsectionTitle'
import MenuItem from './MenuItem'
import ButtonCluster from '../UI/ButtonCluster'

import { mapState } from 'vuex'

import VueClickaway from 'vue-clickaway'
import ToggleSelect from '../../toggle-select'

import _find from 'lodash/Find'

export default {

  name: 'MenuSubsection',
  mixins : [ VueClickaway.mixin, ToggleSelect ], 
  props : {
    'subsection' : Object
  },
  components : {
    draggable,
    'editable-text' : EditableTextField,
    'subsection-title' : MenuSubsectionTitle,
    'menu-item' : MenuItem,
    'button-cluster' : ButtonCluster
  },

  methods : {
    addPriceColumn(item, event) {
      event.stopPropagation();
      if( !this.subsection.subsection_price_columns ) {
        this.subsection.subsection_price_columns  = []
      }
      this.subsection.subsection_price_columns.push({'price':''})
      let self = this;
      this.$nextTick().then( ()=> {
        let priceIndex = this.subsection.subsection_price_columns.length-1;
        self.$refs.subsectionTitle.focusNewPrice(priceIndex)
      })

    }, // addPriceColumn    

    addItem( ) {
      let newItemNum = this.subsection.items.length + 1

      let newItem = {
        item_title : 'New Item',
        item_uuid : Date.now() + newItemNum,
        item_prices : [],
        item_description : '',
        item_addons : [],
        item_isSpecial : false,
        new : true

      };
      // WP ACF REST returns false for empty array
      if( "undefined" === typeof this.subsection.items || !this.subsection.items ) {
        this.subsection.items = []
      }

      this.subsection.items.push(newItem);
    },

    removeItem(item_id) {
      this.subsection.items = this.subsection.items.filter(item=> item.item_uuid !== item_id )      
    }, // removeItem

    onDragStart() {
      this.dragging = true
      this.selected = true
      this.$emit('itemDragStart');
    }, // onDragStart


    resetDeleteButton() {
      let deleteBtn = _find(this.buttons, btn => { return btn.title == this.confirmMsg; })
      deleteBtn.title = 'Subsection';
      deleteBtn.icon = this.deleteIcon;
      deleteBtn.class = '';
      this.confirmDelete = false;
    }, // resetDeleteButton

    deleteConfirmationCheck() {
      let deleteBtn = _find(this.buttons, btn => { return btn.icon == this.deleteIcon; })
      deleteBtn.title = this.confirmMsg;
      deleteBtn.icon = false;
      deleteBtn.class = 'delete-confirmation';
      this.confirmDelete = true;
    }, // deleteConfirmationCheck    

    deleteConfirmation(section) {
      if( !this.confirmDelete ) {
        this.deleteConfirmationCheck();
        this.confirmationTimeout = setTimeout( this.resetDeleteButton, 2000)
        return false;
      } else {
        clearTimeout(this.confirmationTimeout)
        this.$emit('removeSubsection', this.subsection.subsection_uuid);
      }
      
    }, // deleteConfirmation


  },

  computed: {
    showExtras() {
      return !this.disabled && (this.showUI || this.hovering || this.selected);
    },
    ...mapState(['wpData'])
  },

  created() {
  }, // created

  data () {
    return {
      hovering : false,
      dragging : false,
      confirmDelete : false,
      confirmMsg : 'You Sure?',
      deleteIcon : 'delete',      
      buttons : [
        {
          title : 'Item',
          icon : 'add_circle',
          // iconOnly : true,
          // dragGroup : {
          //   name : 'item-addons',
          //   pull : 'false'
          // },
          clickHandler : this.addItem,
          // dragStartAction : this.addButtonDragStart,
          // dragEndAction : this.addButtonDragEnd,
          // dragChangeAction : this.addButtonDragChange,
          mouseupAction : ()=>{},
          mousedownAction : ()=>{},

        },
        {
          title : 'Subsection',
          icon : 'delete',
          // iconOnly : true,
          class : 'btn-delete-gray',
          clickHandler : this.deleteConfirmation,
          mouseupAction : ()=>{},
          mousedownAction : ()=>{},
        }        
      ]         
    }
  }
}
</script>

<style lang="scss">
$borderWidth : 2px;
$padding : 12px;
$orange: #f16a0a;
$pink:#f127a0;
$navy:#1b3dbf;
$highlight:$navy; 
@mixin hoverElem {
  cursor:pointer;
  z-index:10;
  &:before {
    content : '';
    position:absolute;
    z-index:-1;
    height:calc(100% + #{$borderWidth*2});
    width:calc(100% + #{($borderWidth*2 + $padding*2)});
    right:-#{$padding};
    top:0px;
    border:$borderWidth solid darken(white, 7%);
    // border-bottom-color:$highlight; // orange    

  }
  &:not(.selected):before{ 
    background-color:darken(white, 3%);
  }

}

.subsection {
  position:relative; 

  &:hover, &.selected {
    > .button-cluster {
      display:flex;
      bottom:-40px;
    }
  }
  &:not(.ui-hidden):hover {
    @include hoverElem;
  }
  
  &.selected {
    @include hoverElem;
    &:before {
      // z-index:10;
      background-color:white;
      // border-width:0 0 2px;
      border-color: darken(white, 7%);
      border-bottom-color:$highlight;
      border-bottom-style:solid;
      // box-shadow:0px 12px 35px -17px $highlight;
      // border-bottom-color:transparent;
      width:calc(100% + #{($borderWidth*2 + $padding*4)});
      right:-#{$padding*2};
    }
  }

  &.ui-hidden {
    &:before {
      display:none !important;
    }
  }


}  
</style>



// WEBPACK FOOTER //
// src/components/Menus/MenuSubsection.vue